// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6864dd77","703":"6f22903a"}[chunkId] + ".chunk.js";
};